import React, { useEffect } from 'react';
import { isAndroid, isIOS, isWindows, isMacOs } from 'react-device-detect';
import Layout from '../components/layout';
import Seo from '../components/seo';
import mainImg from '../images/main.png';
import logo from '../images/logo.png';

const DownloadApp = () => {
  const handleDownload = () => {
    if (isWindows || isAndroid) {
      window.open('https://play.google.com/store/apps/details?id=com.orchata.store', '_blank');
    }
    if (isMacOs || isIOS) {
      window.open('https://apps.apple.com/app/id1567133509', '_blank');
    }
  };

  useEffect(() => {
    if (isAndroid) {
      window.open('https://play.google.com/store/apps/details?id=com.orchata.store', '_system');
      return;
    }
    if (isIOS) {
      window.open('https://apps.apple.com/app/id1567133509', '_system');
      return;
    }
  }, []);

  return (
    <Layout>
      <Seo title="Deacarga la App" />
      <div className="font-sans grid lg:grid-flow-col lg:grid-cols-2 h-screen">
        <div className="lg:space-y-20 w-10/12 m-auto">
          <img className="hidden lg:block h-9 w-auto" src={logo} alt="orchata logo" />
          <img className="lg:hidden h-10 w-auto" src={logo} alt="orchata logo" />
          <div className="space-y-10">
            <p className="text-gray font-semibold text-xs">TE PRESENTAMOS ORCHATA</p>
            <h1 className="font-sans text-pink text-4xl lg:text-7xl">
              Tu super en <br /> 15 minutos
            </h1>
            <p className="text-gray-paragraph">Te regalamos $100 de descuento en tu primer pedido.</p>
            <div>
              <button
                onClick={handleDownload}
                className="bg-pink text-white shadow-lg rounded-full font-semibold px-5 py-3"
              >
                Descarga la app
              </button>
            </div>
          </div>
        </div>
        <div className="lg:h-screen flex items-center" style={{ backgroundColor: '#FFD8EC' }}>
          <img className="mx-auto" src={mainImg} alt="screen products" />
        </div>
      </div>
    </Layout>
  );
};

export default DownloadApp;
